module.exports = __webpack_public_path__ + "img/ltgold_liquiditgold.b58cb75.png";